import $ from 'jquery';


export default () => {

    $(".button-share svg").click(function (e) {
        $.each($(this).parent().parent().find("span"), function (n, el) {
            // console.log($(el));
            $(el).toggleClass("make-visible");
        });
    });

};



// WEBPACK FOOTER //
// ./scripts/libs/share.js